import Cookie from 'js-cookie'
import { getLogger } from '../debuggers'
import { customizeError } from '../errors'

const logger = getLogger('Cookies')

/**
 * To delete a cookie.
 */
export const deleteCookie = key => {
  try {
    Cookie.remove(key)
  } catch (error) {
    logger.warn(`Unable to delete cookie ${key}`, error)

    throw customizeError({ originalError: error, reason: 'DELETE_COOKIE_ERROR' })
  }
}

/**
 * To get a value from cookie.
 */
export const getCookie = (key, options = {}) => {
  try {
    let entry = Cookie.get(key)

    if (entry && options.base64) {
      entry = window.atob(entry)
    }

    if (entry && options.json) {
      entry = JSON.parse(entry)
    }

    return entry
  } catch (error) {
    logger.warn(`Unable to get data from cookie ${key}`, error)

    throw customizeError({ originalError: error, reason: 'GET_COOKIE_ERROR' })
  }
}

/**
 * To put a value into cookie.
 */
export const putCookie = (key, value, options = {}) => {
  const { base64, json, ...customConfig } = options
  const config = { ...customConfig, path: '/' }

  try {
    let entry = json ? JSON.stringify(value) : value

    if (base64) {
      entry = window.btoa(entry)
    }

    Cookie.set(key, entry, config)
  } catch (error) {
    logger.warn(`Unable to put data into cookie ${key}`, error)

    throw customizeError({ originalError: error, reason: 'PUT_COOKIE_ERROR' })
  }
}
